import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './frontend.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import {BookingWidget} from "./booking-form/booking-widget";

const EnquiryForm = ({ config, apiUrl }) => {
    const [formData, setFormData] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [categoryCode, setCategoryCode] = useState(config.categoryCode || '');
    const [productCode, setProductCode] = useState(config.productCode || '');

    const { fields, title, bgColor, width, alignment, message, showStickyButton, stickyButtonPosition, stickyButtonIcon, customCSS, buttonText, renderInline } = config;

    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post(apiUrl, formData)
            .then(response => {
                setSubmitted(true);
                setTimeout(() => setSubmitted(false), 3000);
                setFormData({});
            })
            .catch(error => {
                console.error('Error submitting form:', error);
            });
    };

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };

    useEffect(() => {
        if (config.showCategoryForm) {
            const url = window.location.href;
            const categoryMatch = url.match(/category\/([^/]+)/);
            if (categoryMatch && categoryMatch[1]) {
                setCategoryCode(categoryMatch[1]);
            } else {
                const productMatch = url.match(/product-detail\/([^/]+)/);
                if (productMatch && productMatch[1]) {
                    setProductCode(productMatch[1]);
                } else {
                    const customUrlMatch = url.match(/moneymarche.com\/([^/]+)/);
                    if (customUrlMatch && customUrlMatch[1]) {
                        setCategoryCode(customUrlMatch[1]);
                    }
                }
            }
        }
    }, []);

    return (
        <div className='react-common-enquiry-form-block'>
            {/* Render BookingWidget only if productCode or categoryCode is set */}
            {(productCode || categoryCode) && renderInline && (
                <div className='booking-widget-inline-container'>
                    <BookingWidget config={config} categoryCode={categoryCode} productCode={productCode} isVisible={true} />
                </div>
            )}
            {!renderInline && <>
                {showStickyButton ? (
                    <button className={`sticky-button ${stickyButtonPosition}`} onClick={togglePopup}>
                        {stickyButtonIcon ? (
                            <i className={stickyButtonIcon}></i>
                        ) : (
                            <FontAwesomeIcon icon={faEnvelope} />
                        )}
                    </button>
                ) : (
                    <>
                        {(config.formId || config.showCategoryForm) && 
                            <button 
                                onClick={togglePopup} 
                                className={config.buttonClass || ''} 
                                style={config.buttonStyle ? JSON.parse(config.buttonStyle) : {}}
                            >
                                {config.buttonText || 'Submit'}
                            </button>
                        }
                    </>
                )}

                {!showStickyButton && fields && fields.length && !config.formId && !config.showCategoryForm && (
                    <div style={{ width: width, textAlign: alignment, position: 'relative', backgroundColor: bgColor }}>
                        <form onSubmit={handleSubmit} className="enquiry-form">
                            <h3>{title}</h3>
                            {fields.map((field, index) => (
                                <div key={index} className="form-group">
                                    <label>{field.name}</label>
                                    {field.type === 'textarea' ? (
                                        <textarea
                                            value={formData[field.name] || ''}
                                            onChange={(e) => handleChange(field.name, e.target.value)}
                                            required
                                        />
                                    ) : (
                                        <input
                                            type={field.type}
                                            value={formData[field.name] || ''}
                                            onChange={(e) => handleChange(field.name, e.target.value)}
                                            required
                                        />
                                    )}
                                </div>
                            ))}
                            <button type="submit">Submit</button>
                        </form>
                        {submitted && (
                            <div className="overlay">
                                <div className="submission-message-container">
                                    <div className="tick-icon">&#10004;</div>
                                    <div className="submission-message">{message}</div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {showPopup && (
                    <div className="popup-overlay" onClick={togglePopup}>
                        <div className="popup-content" onClick={(e) => e.stopPropagation()} style={{padding: '10px'}}>
                            <button className="close-popup" onClick={togglePopup}>×</button>

                            {(config.formId || config.showCategoryForm) && 
                                <BookingWidget config={config} categoryCode={categoryCode} productCode={productCode} isVisible={showPopup} /> 
                            }
                            

                            {(!config.formId && !config.showCategoryForm) && (
                            <>
                                <form onSubmit={handleSubmit} className="enquiry-form">
                                <h3>{title}</h3>
                                {fields.map((field, index) => (
                                    <div key={index} className="form-group">
                                        <label>{field.name}</label>
                                        {field.type === 'textarea' ? (
                                            <textarea
                                                value={formData[field.name] || ''}
                                                onChange={(e) => handleChange(field.name, e.target.value)}
                                                required
                                            />
                                        ) : (
                                            <input
                                                type={field.type}
                                                value={formData[field.name] || ''}
                                                onChange={(e) => handleChange(field.name, e.target.value)}
                                                required
                                            />
                                        )}
                                    </div>
                                ))}
                                <button type="submit">Submit</button>
                            </form>
                            {submitted && (
                            <div className="overlay">
                                <div className="submission-message-container">
                                    <div className="tick-icon">&#10004;</div>
                                    <div className="submission-message">{message}</div>
                                </div>
                            </div>
                            )}
                            </>
                            )}
                        </div>
                    </div>
                )}
                <style>{customCSS}</style>
            </>}
        </div>
    );
};

export default EnquiryForm;